import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IDeleteGroupsParams {
  ids: string[];
}

export interface IDeleteGroupsResult extends IResult {
}

export class DeleteGroupsRequest extends Request<IDeleteGroupsParams, IDeleteGroupsResult> {
  constructor(ids: string[]) {
    super('deleteGroups', { ids: ids });
  }
}
